import React from 'react';
import styled from 'styled-components';
import { SYS_SPACE_FIXED_400 } from '@oneaudi/unified-web-common';
import { TextLink } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import { messages } from '../../../i18n/messages';
import { useGeolocation } from '../../../hooks/useMapGeolocation';
import trackingContext from '../../../contexts/tracking-context';
import { trackUserLocationAction } from '../../../utils/trackingUtils';
import { TrackingEvents } from '../../../utils/trackingService';
import searchGroupContext from '../../../contexts/search-group-context';

const GpsButton = () => {
  const { triggerGeolocationSearch } = useGeolocation();
  const { trackingService: tService } = trackingContext.useTrackingState();
  const { onToggle } = searchGroupContext.useToggle();
  const buttonText = useI18n(messages.gps_button_text);

  async function handleGpsButtonClick() {
    trackUserLocationAction(tService, TrackingEvents.LOCATE_USER);
    await triggerGeolocationSearch();
    onToggle(false);
  }

  return (
    <GpsButtonContainer
      onClick={() => {
        void handleGpsButtonClick();
      }}
      data-test-id="gps-button"
    >
      <TextLink variant="standalone" icon="gps" onClick={() => {}} size="md" iconPosition="leading">
        {buttonText}
      </TextLink>
    </GpsButtonContainer>
  );
};

const GpsButtonContainer = styled.div`
  margin-top: ${SYS_SPACE_FIXED_400};
  cursor: pointer;

  button {
    text-decoration: none;
  }
`;

export default GpsButton;
